import { QueryObserverOptions, useQuery } from 'react-query';

import FunctionKey from 'constants/functionKey';
import { useDlVaultContract } from 'clients/contracts/hooks';
import getNetworkRewardRecordsCount, { 
  GetNetworkRewardRecordsCountInput, 
  GetNetworkRewardRecordsCountOutput 
} from '.';

type TrimmedGetNetworkRewardRecordsCountInput = Omit<GetNetworkRewardRecordsCountInput, 'dlVaultContract'>;

export type UseGetNetworkRewardRecordsCountQueryKey = [
  FunctionKey.GET_NETWORK_REWARD_RECORDS_COUNT,
  TrimmedGetNetworkRewardRecordsCountInput,
];

type Options = QueryObserverOptions<
  GetNetworkRewardRecordsCountOutput,
  Error,
  GetNetworkRewardRecordsCountOutput,
  GetNetworkRewardRecordsCountOutput,
  UseGetNetworkRewardRecordsCountQueryKey
>;

const useGetNetworkRewardRecordsCount = (input: TrimmedGetNetworkRewardRecordsCountInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_NETWORK_REWARD_RECORDS_COUNT, input],
    () => getNetworkRewardRecordsCount({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetNetworkRewardRecordsCount; 